module.exports = __webpack_public_path__ + "media/images/Linkedin-c1a048b195d710b9bf2f129e403d67f2.svg";